/* custom variant modal starts */
$(document).ready(function () {
    // ==========================================
    // 1. CONFIGURATION & STATE VARIABLES
    // ==========================================
    const IS_DRAWER_CART = ($("#variantModal").attr("data-cart-type") || "drawer") === "drawer";
    const currentPricelist = typeof getCookie === "function" ? getCookie("pricelist") : null;
    
    let currentModalProduct = null;
    let selectedVariant = null;
    let preSelectedColor = null;

    // ==========================================
    // 2. HELPER & UTILITY FUNCTIONS
    // ==========================================
    const buildCustomProperties = (
        external_price,
        external_token,
        pricelist
    ) => {
        const properties = {};
        if (external_price) properties._external_price = String(external_price);
        if (external_token) properties._external_token = String(external_token);
        if (pricelist && external_price)
            properties._external_pricelist = pricelist;
        return properties;
    };

    const getPromotionalPricing = (variantId, defaultPrice, defaultCompare) => {
        let price = defaultPrice;
        let comparePrice = defaultCompare;
        let properties = {};

        if (
            typeof currentPricelist !== "undefined" &&
            typeof benefits !== "undefined" &&
            benefits[variantId] &&
            benefits[variantId][currentPricelist]
        ) {
            const promo = benefits[variantId][currentPricelist];
            if (promo.closed_shop_price !== undefined)
                price = promo.closed_shop_price;
            if (promo.compare_price !== undefined)
                comparePrice = promo.compare_price;

            properties = buildCustomProperties(
                promo.closed_shop_price,
                promo.closed_shop_token,
                currentPricelist
            );
        }

        return { price, comparePrice, properties };
    };

    const togglePromotionalText = (promoPricing) => {
        const $promoText = $("#modalPromotionalText");
        const isPromotional = Object.keys(promoPricing.properties).length > 0;
        
        if (isPromotional) {
            $promoText.removeClass("is-hidden");
        } else {
            $promoText.addClass("is-hidden");
        }
    };

    //PREORDER-FIX-2026-09-23
    function getVariantPreorderState(product, variant) {
        if (!product) return false;
        if (product.productPreorder === true) return true;
        if (!variant) return false;
        const map = product.variantPreorderMap || {};
        return map[variant.id] === true;
    }

    function getCartSectionIds() {
        const sectionElements = document.querySelectorAll(
            "cart-items-component"
        );
        let sectionIds = [];

        sectionElements.forEach((el) => {
            const id =
                el.dataset.sectionId ||
                (el.closest('[id^="shopify-section-"]') &&
                    el
                        .closest('[id^="shopify-section-"]')
                        .id.replace("shopify-section-", ""));
            if (id && !sectionIds.includes(id)) {
                sectionIds.push(id);
            }
        });

        return sectionIds.join(",");
    }

    function getCartRoutingPayload() {
        return IS_DRAWER_CART ? { sections: getCartSectionIds() } : {};
    }

    function getProductUrl(handle) {
        const isCollectionPage =
            window.location.pathname.match(/\/collections\/[^\/]+$/) ||
            window.location.pathname.match(/\/collections\/[^\/]+\/$/);

        const collectionHandle = window.location.pathname.match(
            /\/collections\/([^\/]+)/
        );

        if (isCollectionPage && collectionHandle) {
            return (
                "/collections/" + collectionHandle[1] + "/products/" + handle
            );
        }

        return "/products/" + handle;
    }

    function checkOptionAvailability(product, optionIndex, optionValue) {
        return product.variants.some((variant) => {
            return (
                variant[`option${optionIndex + 1}`] === optionValue &&
                variant.available
            );
        });
    }

    // ==========================================
    // 3. CORE API & ROUTING FUNCTIONS
    // ==========================================
    async function commonAddToCart(items, options = {}, extraPayload = {}) {
        const payload = {
            items: items,
            ...extraPayload,
        };

        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const text = await response.text();
                let errData;
                try {
                    errData = JSON.parse(text);
                } catch (e) {
                    errData = { description: text };
                }
                throw {
                    status: response.status,
                    description:
                        errData.description ||
                        errData.message ||
                        "Unable to add product to cart.",
                };
            }

            const result = await response.json();

            if (typeof options.onSuccess === "function") {
                options.onSuccess(result);
            }

        } catch (error) {
            if (typeof options.onError === "function") {
                options.onError(error);
            } else {
                console.error("Error adding to cart:", error);
            }
        }
    }

    function handleCartDrawer(source, apiResult = null) {
        if (apiResult && apiResult.sections) {
            Object.keys(apiResult.sections).forEach((sectionId) => {
                const html = apiResult.sections[sectionId];
                const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

                if (sectionId === 'header' || sectionId.includes('header')) {
                    
                    const oldBubble = document.querySelector('.cart-bubble');
                    const newBubble = parsedHTML.querySelector('.cart-bubble');
                    if (oldBubble && newBubble) {
                        oldBubble.innerHTML = newBubble.innerHTML;
                    }

                    const oldCartItems = document.querySelector('cart-items-component');
                    const newCartItems = parsedHTML.querySelector('cart-items-component');
                    if (oldCartItems && newCartItems) {
                        oldCartItems.innerHTML = newCartItems.innerHTML;
                    }
                    
                    return; 
                }

                const sectionElement = document.getElementById(`shopify-section-${sectionId}`) ||
                                        document.querySelector(`[data-section-id="${sectionId}"]`);

                if (sectionElement) {
                    const newContent = parsedHTML.querySelector(`#shopify-section-${sectionId}`) || 
                                    parsedHTML.querySelector(`[data-section-id="${sectionId}"]`);
                                    
                    if (newContent) {
                        sectionElement.innerHTML = newContent.innerHTML;
                    }
                }
            });
        }

        document.dispatchEvent(
            new CustomEvent("cart:update", {
                bubbles: true,
                detail: {
                    data: {
                        source: source || "product-form-component",
                    },
                },
            })
        );

        const cartDlg = document.querySelector("dialog.cart-drawer__dialog");
        if (cartDlg) {
            cartDlg.setAttribute("scroll-lock", "");
            cartDlg.setAttribute("open", "");
        }
    }

    function handleCartPage(result) {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((cart) => {
                const detailData = {
                    itemCount: cart.item_count,
                    source: 'custom-add-to-cart',
                    sections: cart.sections,
                };

                if (window.CartUpdateEvent) {
                    document.dispatchEvent(new window.CartUpdateEvent(cart, 'custom-add-to-cart', detailData));
                } else {
                    const eventName = (window.ThemeEvents && window.ThemeEvents.cartUpdate) || 'cart:update';
                    document.dispatchEvent(
                        new CustomEvent(eventName, {
                            bubbles: true,
                            detail: { resource: cart, sourceId: 'custom-add-to-cart', data: detailData },
                        })
                    );
                }
            })
            .catch((error) => console.error('Failed to refresh cart count:', error));

        if (result && result.items?.length > 0) {
            const addedItem = result.items[0];
            document.dispatchEvent(new CustomEvent('AddToCart', {
                detail: { productName: addedItem.product_title, variantName: addedItem.variant_title },
            }));
        }
    }

    function routeAfterCartAction(source, result, isError = false) {
        if (IS_DRAWER_CART) {
            handleCartDrawer(source, isError ? null : result);
        } else {
            isError ? (window.updateCartCount && window.updateCartCount()) : handleCartPage(result);
        }
    }

    // ==========================================
    // 4. UI & DOM MANIPULATION FUNCTIONS
    // ==========================================
    function populateVariantModal(product) {
        const productURL = getProductUrl(product.handle);

        $("#modalProductTitle").text(product.title);
        $("#modalProductTitle").attr("href", productURL);
        $("#modalProductURL").attr("href", productURL);

        const colIdx = product.colorOptionIndex || 1;

        if (preSelectedColor) {
            selectedVariant =
                product.variants.find(function (v) {
                    return (
                        v["option" + colIdx] === preSelectedColor && v.available
                    );
                }) ||
                product.variants.find(function (v) {
                    return v["option" + colIdx] === preSelectedColor;
                }) ||
                product.variants.find(function (v) {
                    return v.available;
                }) ||
                product.variants[0];
        } else if (product.preSelectedVariantId) {
            selectedVariant =
                product.variants.find(function (v) {
                    return v.id == product.preSelectedVariantId;
                }) ||
                product.variants.find(function (v) {
                    return v.available;
                }) ||
                product.variants[0];
        } else {
            selectedVariant =
                product.variants.find(function (v) {
                    return v.available;
                }) || product.variants[0];
        }

        if (selectedVariant) {
            $("#variantModal").find('input[name="id"]')
                .val(selectedVariant.id)
                .attr("value", selectedVariant.id);
        }

        if (selectedVariant && selectedVariant.sku) {
            $("#modalProductSku")
                .text("Article No. " + selectedVariant.sku)
                .show();
        } else {
            $("#modalProductSku").hide();
        }

        let initialImage = product.activeSwatchImage || null;
        if (
            !initialImage &&
            selectedVariant &&
            selectedVariant.featured_image &&
            selectedVariant.featured_image.src
        ) {
            initialImage = selectedVariant.featured_image.src;
        }
        if (!initialImage) initialImage = product.image;
        $("#modalProductImage").attr("src", initialImage);

        const $productPrice = $("#modalProductPrice");
        const $comparePrice = $("#modalProductCompareAtPrice");
        const isVariantSelected = !!selectedVariant;

        const baseVariantId = isVariantSelected
            ? selectedVariant.id
            : product.variants[0].id;
        const rawPrice = isVariantSelected
            ? selectedVariant.price
            : product.rawPrice;
        const rawCompareAtPrice = isVariantSelected
            ? selectedVariant.compare_at_price
            : product.rawComparePrice;

        const promoPricing = getPromotionalPricing(
            baseVariantId,
            rawPrice,
            rawCompareAtPrice
        );

        if (product.comingSoon) {
            // Hide the wrapper and remove text values entirely
            $(".product-price-wrapper").hide();
            $productPrice.text(""); 
            $comparePrice.text("");
        } else {
            $(".product-price-wrapper").show();
            $productPrice.show().text(formatMoney(promoPricing.price, theme.moneyFormat));

            const hasComparePrice = promoPricing.comparePrice > promoPricing.price;
            $comparePrice
                .text(formatMoney(promoPricing.comparePrice, theme.moneyFormat))
                .toggleClass("is-hidden", !hasComparePrice)
                .toggle(hasComparePrice);
                
            togglePromotionalText(promoPricing);
        }

        buildVariantOptions(product);

        $("#modalQuantityInput").val(1);

        updateAddToCartButtonState();
    }

    function buildVariantOptions(product) {
        const $container = $("#modalVariantOptions");
        $container.empty();

        if (!product.options || product.options.length === 0) {
            return;
        }

        product.options.forEach((option, optionIndex) => {
            const optionName = option.name;
            const optionValues = option.values;

            if (optionValues.length <= 1) {
                return;
            }

            const isColorOption =
                optionName.toLowerCase().includes("color") ||
                optionName.toLowerCase().includes("colour");

            const $optionDiv = $('<div class="product-option"></div>');

            let initialValue = optionValues[0];
            if (
                isColorOption &&
                preSelectedColor &&
                optionValues.includes(preSelectedColor)
            ) {
                initialValue = preSelectedColor;
            } else if (selectedVariant) {
                initialValue = selectedVariant[`option${optionIndex + 1}`];
            }

            $optionDiv.append(`
                    <span>${optionName} : <span class="selected-option" data-option-index="${optionIndex}" style="display: none;">${initialValue}</span></span>
                `);

            if (isColorOption) {
                const $colorWrapper = $(
                    '<div class="product-selector-wrapper"></div>'
                );
                const $colorSelector = $(
                    '<div class="product-selector"></div>'
                );

                optionValues.forEach((value) => {
                    const isActive = value === initialValue;

                    const colorBackground =
                        product.colorHexMap && product.colorHexMap[value]
                            ? product.colorHexMap[value]
                            : value;

                    const $colorBtn = $(`
                            <button 
                                type="button" 
                                class="product-selector-color ${
                                    isActive ? "active" : ""
                                }" 
                                data-option-index="${optionIndex}"
                                data-option-value="${value}"
                                style="background: ${colorBackground}"
                                title="${value}"
                            >
                                <span class="visually-hidden">${value}</span>
                            </button>
                        `);

                    $colorSelector.append($colorBtn);
                });

                $colorWrapper.append($colorSelector);
                $optionDiv.append($colorWrapper);
            } else {
                const $sizeOptions = $('<div class="size-options"></div>');

                optionValues.forEach((value) => {
                    const isActive = value === initialValue;
                    const isAvailable = checkOptionAvailability(
                        product,
                        optionIndex,
                        value
                    );

                    const $sizeBtn = $(`
                            <button 
                                class="size-btn ${isActive ? "active" : ""} ${
                        !isAvailable ? "unavailable" : ""
                    }" 
                                data-option-index="${optionIndex}"
                                data-option-value="${value}"
                                ${!isAvailable ? "disabled" : ""}
                            >
                                ${value}
                            </button>
                        `);

                    $sizeOptions.append($sizeBtn);
                });

                $optionDiv.append($sizeOptions);
            }

            $container.append($optionDiv);
        });

        preSelectedColor = null;

        attachVariantOptionListeners();
    }

    function attachVariantOptionListeners() {
        $(".custom-variant-modal .product-selector-color")
            .off("click")
            .on("click", function () {
                const $this = $(this);
                const optionIndex = $this.data("option-index");
                const optionValue = $this.data("option-value");

                $this.siblings().removeClass("active");
                $this.addClass("active");

                $(`.selected-option[data-option-index="${optionIndex}"]`).text(
                    optionValue
                );

                updateSelectedVariant();
            });

        $(".custom-variant-modal .size-btn")
            .off("click")
            .on("click", function () {
                const $this = $(this);

                if ($this.hasClass("unavailable")) {
                    return;
                }

                const optionIndex = $this.data("option-index");
                const optionValue = $this.data("option-value");

                $this.siblings().removeClass("active");
                $this.addClass("active");

                $(`.selected-option[data-option-index="${optionIndex}"]`).text(
                    optionValue
                );

                updateSelectedVariant();
            });
    }

    function updateSelectedVariant() {
        if (!currentModalProduct) return;

        const selectedOptions = {};
        $(".selected-option[data-option-index]").each(function () {
            const index = $(this).data("option-index");
            selectedOptions[index] = $(this).text();
        });

        const matchingVariant = currentModalProduct.variants.find((variant) => {
            return Object.keys(selectedOptions).every((optionIndex) => {
                return (
                    variant[`option${parseInt(optionIndex) + 1}`] ===
                    selectedOptions[optionIndex]
                );
            });
        });

        if (matchingVariant) {
            selectedVariant = matchingVariant;

            $("#variantModal").find('input[name="id"]')
                .val(matchingVariant.id)
                .attr("value", matchingVariant.id);

            if (matchingVariant.sku) {
                $("#modalProductSku")
                    .text("Article No. " + matchingVariant.sku)
                    .show();
            } else {
                $("#modalProductSku").hide();
            }

            const { id, price, compare_at_price } = matchingVariant;
            const $comparePrice = $("#modalProductCompareAtPrice");

            const promoPricing = getPromotionalPricing(
                id,
                price,
                compare_at_price
            );

            if (currentModalProduct.comingSoon) {
                // Hide the wrapper and remove text values entirely
                $(".product-price-wrapper").hide();
                $("#modalProductPrice").text("");
                $comparePrice.text("");
            } else {
                $(".product-price-wrapper").show();
                $("#modalProductPrice").show().text(formatMoney(promoPricing.price, theme.moneyFormat));

                const hasComparePrice = promoPricing.comparePrice > promoPricing.price;
                $comparePrice
                    .text(formatMoney(promoPricing.comparePrice, theme.moneyFormat))
                    .toggleClass("is-hidden", !hasComparePrice)
                    .toggle(hasComparePrice);
                    
                togglePromotionalText(promoPricing);
            }

            if (
                matchingVariant.featured_image &&
                matchingVariant.featured_image.src
            ) {
                $("#modalProductImage").attr(
                    "src",
                    matchingVariant.featured_image.src
                );
            }

            updateAddToCartButtonState();
        }
    }

    function updateAddToCartButtonState() {
        const $addBtn = $("#modalAddToCart");

        if (!selectedVariant) {
            $addBtn.prop("disabled", true).text("Select Options").attr("title", "Select Options");
            return;
        }

        if (currentModalProduct.comingSoon) {
            $(".product-option.quantity-options").hide();
            $addBtn.prop("disabled", true).text("Coming Soon").attr("title", "Coming Soon");
            return;
        }

        if (selectedVariant.available) {
            // const buttonText = currentModalProduct.preorder
            //     ? "Preorder"
            //     : "Buy now";
            const buttonText = getVariantPreorderState(currentModalProduct, selectedVariant)
                ? "Preorder"
                : "Add to Cart"; //PREORDER-FIX-2026-09-23

            $addBtn.prop("disabled", false).text(buttonText).attr("title", buttonText);
        } else {
            $addBtn.prop("disabled", true).text("Not Available").attr("title", "Not Available");
        }
    }

    function showCartToast(message, type, onOkCallback) {
        if (!message) return;

        const icon = type === "error" ? "⚠️" : "✅";
        $("#customNotificationIcon").text(icon);
        $("#customNotificationMsg").text(message);
        $("#customNotificationModal").css("display", "flex");

        $("#customNotificationClose, #customNotificationOverlay")
            .off("click")
            .on("click", function () {
                $("#customNotificationModal").css("display", "none");
                if (typeof onOkCallback === "function") {
                    onOkCallback();
                }
            });
    }

    function closeModal() {
        $("#variantModal").removeClass("active");
        $("body").css("overflow", "unset");
        setTimeout(() => {
            $("#variantModal").css("display", "none");
        }, 300);
    }

    // ==========================================
    // 5. EVENT LISTENERS
    // ==========================================

    // Product Card Color Swatch Click
    $(document).on(
        "click",
        ".variant-modal .product-selector-color",
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $swatch = $(this);
            const $productCard = $swatch.closest(".product-content");
            const variantImage = $swatch.data("image");
            const variantPrice = $swatch.data("price");
            const comparePrice = $swatch.data("compare-at-price");
            const variantId = $swatch.data("variant-id");
            const colorName = $swatch.data("color");

            $swatch.siblings(".product-selector-color").removeClass("active");
            $swatch.addClass("active");

            const $productCardWrapper = $swatch.closest(
                ".card-wrapper, .product-card, .card"
            );
            const $productImage = $productCardWrapper.find("img").first();
            if ($productImage.length && variantImage) {
                $productImage.attr("src", variantImage);
            }

            const $priceElement = $productCard.find("[data-actual-price]");
            if ($priceElement.length && variantPrice) {
                $priceElement.text(variantPrice);
            }

            if (comparePrice) {
                const $comparePriceElement = $productCard.find(
                    "[data-compare-price]"
                );
                if ($comparePriceElement.length) {
                    $comparePriceElement.text(comparePrice);
                }
            }

            const $productBtn = $productCard.find(".product-btn");
            if ($productBtn.length) {
                $productBtn.attr("data-selected-variant-id", variantId);
                $productBtn.attr("data-selected-color", colorName);
            }
        }
    );

    // Standard / More-Color Add To Cart Click
    $(document).on(
        "click",
        '.product-btn button[type="submit"], .more-color-btn',
        function (e) {
            const $button = $(this);
            const $productBtn = $button.closest(".product-btn").length
                ? $button.closest(".product-btn")
                : $button
                      .closest(".product-list-card, .product-content")
                      .find(".product-btn");

            if (!$productBtn.length) {
                e.preventDefault();
                const $card = $button.closest(".product-list-card, .product-content, .card-wrapper, .card");
                const productLink = $card.find('a[href*="/products/"]').first().attr("href");
                
                if (productLink) {
                    window.location.href = productLink;
                }
                return;
            }

            const variantCount =
                parseInt($productBtn.data("has-multiple-variants")) || 1;

            if (variantCount > 1) {
                e.preventDefault();
                e.stopPropagation();

                const preSelectedVariantId = $productBtn.data(
                    "selected-variant-id"
                );

                const $thisCardSwatch = $button
                    .closest(".product-content")
                    .find(".product-selector-color.active");

                const cardColorHexMap = {};
                $button
                    .closest(".product-content")
                    .find(".product-selector-color")
                    .each(function () {
                        const swatchColor = $(this).data("color");
                        const swatchHex = $(this).data("color-hex");
                        if (swatchColor && swatchHex) {
                            cardColorHexMap[swatchColor] = swatchHex;
                        }
                    });

                currentModalProduct = {
                    id: $productBtn.data("product-id"),
                    handle: $productBtn.data("product-handle"),
                    title: $productBtn.data("product-title"),
                    image: $productBtn.data("product-image"),
                    variants: JSON.parse(
                        $productBtn.attr("data-product-variants") || "[]"
                    ),
                    options: JSON.parse(
                        $productBtn.attr("data-product-options") || "[]"
                    ),
                    colorOptionIndex:
                        parseInt($productBtn.data("color-option-index")) || 1,
                    preSelectedVariantId: preSelectedVariantId,
                    activeSwatchImage: $thisCardSwatch.data("image") || null,
                    activeSwatchColor: $thisCardSwatch.data("color") || null,
                    colorHexMap: cardColorHexMap,
                };

                const $priceElement = $button
                    .closest(".product-content")
                    .find("[data-actual-price]");
                const $comparePriceElement = $button
                    .closest(".product-content")
                    .find("[data-compare-price]");

                currentModalProduct.price = $priceElement.text() || "";
                currentModalProduct.rawPrice =
                    $priceElement.data("raw-price") || 0;

                currentModalProduct.comparePrice =
                    $comparePriceElement.text() || "";
                currentModalProduct.rawComparePrice =
                    $comparePriceElement.data("raw-compare-at-price") || 0;

                currentModalProduct.comingSoon =
                    $productBtn.data("coming-soon");

                // currentModalProduct.preorder =
                //     $productBtn.data("preorder")
                currentModalProduct.productPreorder =
                    $productBtn.data("product-preorder") === true; //PREORDER-FIX-2026-09-23
                currentModalProduct.variantPreorderMap =
                    JSON.parse($productBtn.attr("data-variant-preorder-map") || "{}"); //PREORDER-FIX-2026-09-23

                preSelectedColor =
                    currentModalProduct.activeSwatchColor || null;

                populateVariantModal(currentModalProduct);
                $("#variantModal").css("display", "flex").addClass("active");
                const $modalDetail = $("#variantModal .modal-detail");

                $modalDetail.toggleClass(
                    "coming-soon",
                    !!currentModalProduct.comingSoon
                );
                $("body").css("overflow", "hidden");
            } else {
                const button = this;
                e.preventDefault();

                if (button.classList.contains("klaviyo-bis-trigger")) {
                    console.log("Skipped: Klaviyo BIS trigger active");
                    return;
                }

                const isComingSoon =
                    button.getAttribute("data-coming-soon") === "true";
                if (isComingSoon) return;

                const form = button.closest("product-form-component");
                if (!form) {
                    console.error(
                        "product-form-component not found for this button"
                    );
                    return;
                }

                const variantInput = form.querySelector('input[name="id"]');
                if (!variantInput || !variantInput.value) {
                    console.error("Variant ID not found inside form");
                    return;
                }

                const variant = parseInt(variantInput.value);

                const promoPricing = getPromotionalPricing(variant, 0, 0);
                const properties = promoPricing.properties;

                const lineItem = {
                    id: variant,
                    quantity: 1,
                };

                if (Object.keys(properties).length > 0) {
                    lineItem.properties = properties;
                }

                const extraPayload = getCartRoutingPayload();

                commonAddToCart(
                    [lineItem],
                    {
                        onSuccess: function (result) {
                            routeAfterCartAction("custom-add-to-cart", result);
                        },
                        onError: function(error) {
                            console.error("Standard Add to Cart Error:", error);
                        }
                    },
                    extraPayload
                );
            }
        }
    );

    // Modal Quantity Controls
    $("#modalQuantityPlus").on("click", function () {
        const $input = $("#modalQuantityInput");
        const currentVal = parseInt($input.val()) || 1;
        $input.val(currentVal + 1);
    });

    $("#modalQuantityMinus").on("click", function () {
        const $input = $("#modalQuantityInput");
        const currentVal = parseInt($input.val()) || 1;
        if (currentVal > 1) {
            $input.val(currentVal - 1);
        }
    });

    $("#modalQuantityInput").on("change", function () {
        const val = parseInt($(this).val()) || 1;
        const safeVal = Math.max(1, val);
        $(this).val(safeVal);
    });

    // Modal Add To Cart Click
    $("#modalAddToCart").on("click", function () {
        if (
            !selectedVariant ||
            !selectedVariant.available ||
            $(this).prop("disabled")
        ) {
            return;
        }

        const quantity = parseInt($("#modalQuantityInput").val()) || 1;
        const $addBtn = $(this);

        const promoPricing = getPromotionalPricing(
            selectedVariant.id,
            selectedVariant.price,
            selectedVariant.compare_at_price
        );

        const lineItem = { id: selectedVariant.id, quantity: quantity };

        if (Object.keys(promoPricing.properties).length > 0) {
            lineItem.properties = promoPricing.properties;
        }

        $addBtn.prop("disabled", true).text("Adding...").attr("title", "Adding...");

        const extraPayload = getCartRoutingPayload();

        //PREORDER-FIX-2026-09-23
        // const buttonText = currentModalProduct.preorder ? "Preorder" : "Buy now"
        const buttonText = getVariantPreorderState(currentModalProduct, selectedVariant)
            ? "Preorder"
            : "Add to Cart";


        commonAddToCart(
            [lineItem],
            {
                source: "product-form-component",
                triggerRouting: false,
                onSuccess: function (result) {
                    $addBtn.prop("disabled", false).text(buttonText).attr("title", buttonText);

                    $("#variantModal").removeClass("active");
                    $("body").css("overflow", "unset");
                    $("#variantModal").css("display", "none");

                    routeAfterCartAction("product-form-component", result);
                },
                onError: function (error) {
                    $addBtn.prop("disabled", false).text(buttonText).attr("title", buttonText);

                    $("#variantModal").removeClass("active");
                    $("body").css("overflow", "unset");
                    $("#variantModal").css("display", "none");

                    if (error.status === 422) {
                        const msg =
                            error.description ||
                            "Some items could not be added due to availability.";
                        showCartToast(msg, "error", function () {
                            routeAfterCartAction("product-form-component", null, true);
                        });
                    } else {
                        const errMsg =
                            error.description ||
                            "Unable to add product to cart.";
                        showCartToast(errMsg, "error", null);
                    }
                },
            },
            extraPayload
        );
    });

    // Toast/Notification Overlays
    $("#customNotificationClose, #customNotificationOverlay").on(
        "click",
        function () {
            $("#customNotificationModal").css("display", "none");
        }
    );

    // Modal Close Triggers
    $(".custom-variant-modal .modal-close").on("click", function () {
        closeModal();
    });

    $("#variantModal").on("click", function (e) {
        if ($(e.target).is("#variantModal")) {
            closeModal();
        }
    });

});
/* custom variant modal end */